<!--
 Copyright 2024 Google LLC.

 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

     https://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
-->

<mat-card class="view-experiment-field" *ngIf="isCancelled() else errorCard">
  <mat-card-header>
    <mat-card-title-group>
        <mat-card-subtitle>{{displayFailureOrCancellationCardHeader()}}</mat-card-subtitle>
    </mat-card-title-group>
  </mat-card-header>
  <mat-card-content class="error-message"><p><i>{{displayErrorMessage()}}</i></p>
  </mat-card-content>
</mat-card>
<ng-template #errorCard>
  <mat-card class="view-experiment-field">
    <mat-card-header class="view-exp-card-content" >
      <mat-card-title-group>
        <mat-card-title>Error Details</mat-card-title>
      </mat-card-title-group>
    </mat-card-header>
    <mat-card-content>
      <mat-card class="view-exp-file-field">
        <mat-card-header>
          <mat-card-title-group>
            <mat-card-subtitle i18n>Error Type</mat-card-subtitle>
            <p class="error-type">{{displayErrorType()}}</p>
          </mat-card-title-group>
        </mat-card-header>
      </mat-card>
      <mat-card class="view-exp-file-field">
        <mat-card-header class="error-message-header">
          <mat-card-title-group>
            <mat-card-subtitle i18n>Error Message</mat-card-subtitle>
          </mat-card-title-group>
        </mat-card-header>
        <mat-card-content>
          <p class="error-message">{{displayErrorMessage()}}</p>
        </mat-card-content>
      </mat-card>
    </mat-card-content>
  </mat-card>
</ng-template>
<app-rerun-button [task]="task" [experimentId]="experimentId"/>

